module.exports = __webpack_public_path__ + "img/card-agent-badge.2aae6424.png";